$(document).ready(function(){
  $('span.Customize.lh-customize-pop-open-btn').click(function(){
    $('body').addClass('popup_open');
  });
  
    $('span.pro-custom-n-close-text').click(function(){
    $('body').removeClass('popup_open');
  });
  
  
  
  
  
});





      
